import { Grid } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import styles from "./styles.module.css";
import ButtonGray from "../../utils/CustomFields/ButtonGray";
import { quantityRoundOff, amountRoundOff } from "helpers/NumberFormatHelper";

const ScannedItemsDialog = ({ open, items, onSelect, onClose }) => {
  if (!open) return null;

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContainer}>
        <div className={styles.closeIcoSection}>
          <CloseRoundedIcon onClick={onClose} className={styles.icon} />
        </div>

        <div className={styles.headerSection}>
          <div>
            <h2>Multiple Items Found</h2>
            <h4>Select a product to add to cart</h4>
          </div>
        </div>

        <Grid container className={styles.itemsList}>
          {items.map((item, index) => (
            <Grid item xs={12} key={index} className={styles.itemRow} onClick={() => onSelect(item)}>
              <div className={styles.itemInfo}>
                <span className={styles.itemName}>{item.name}</span>
                <span className={styles.itemDetails}>
                  PLU: {item.plu} | Qty: {quantityRoundOff(item.quantity)}
                </span>
              </div>
              <div className={styles.itemPrice}>
                {item.currency_symbol} {amountRoundOff(item.price)}
              </div>
            </Grid>
          ))}
        </Grid>

        <div className={styles.actionButtons}>
          <ButtonGray onClick={onClose}>Cancel</ButtonGray>
        </div>
      </div>
    </div>
  );
};

export default ScannedItemsDialog;
